import { FlatItem } from '@martech-solution/utils/types';
import { IProvince } from 'src/types/master_data/province.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'master-data/provinces';
// const controller = 'master-data/province-legacies';

// export const getProvinceLegaciesDropdown = async (parentId?: number) => {
//   return await http.get<FlatItem[]>(controller, {
//     params: {
//       parentId
//     }
//   });
// };

export const getProvinceById = async (id: number) => {
  return await http.get<IProvince[]>(`${controller}/${id}`);
};

export const getProvincesDropdown = async () => {
  return await http.get<FlatItem[]>(`${controller}/dropdown`);
};

export const getTreeProvinces = async (provinceId: number) => {
  return await http.get<IProvince[]>(`${controller}/get-tree`, {
    params: {
      provinceId: provinceId
    }
  });
};
